import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useLanguage } from '../hooks/useLanguage';

interface LanguageDialogProps {
  open: boolean;
  onClose: () => void;
}

const LanguageDialog: React.FC<LanguageDialogProps> = ({ open, onClose }) => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();

  const handleChange = (_: React.MouseEvent<HTMLElement>, value: string | null) => {
    if (value) changeLanguage(value);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Language</DialogTitle>
      <DialogContent dividers>
        <Stack alignItems="center" sx={{ py: 1 }}>
          <ToggleButtonGroup
            exclusive
            value={currentLanguage}
            onChange={handleChange}
            color="primary"
          >
            {languages.map((lang) => (
              <ToggleButton key={lang.code} value={lang.code} sx={{ textTransform: 'none' }}>
                {lang.nativeName}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LanguageDialog;


